<template>
	<BaseModal :title="t('title')" v-model="model" noPadding>
		<div class="px-5">
			<div class="text-label-secondary -mt-2 px-3 text-center text-sm">
				{{ t('desc') }}
			</div>
			<SubtitleText class="mt-5">
				{{ t('amount') }}
			</SubtitleText>
			<div
				class="border-separator-secondary shadow-input mt-2 flex max-w-full items-center gap-1.5 rounded-[10px] border bg-black px-4"
			>
				<div class="flex-1 py-3">
					<BaseInput
						id="amountCoins"
						type="text"
						class="placeholder-label-tertiary! h-7.5 w-full text-xl! disabled:opacity-60"
						placeholder="123.45"
						v-model="amount"
						inputmode="decimal"
					/>
				</div>
				<CoinIcon class="h-6 w-6 shrink-0" />
			</div>
		</div>
		<BottomActionsModal class="mt-5 pt-4">
			<BaseButton
				size="lg"
				color="primary"
				class="w-full"
				@click="tip()"
				:loading="loading"
			>
				{{ t('tip') }}
			</BaseButton>
		</BottomActionsModal>
	</BaseModal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import BaseModal from './BaseModal.vue'
import BaseButton from '../BaseButton.vue'
import { useI18n } from 'vue-i18n'
import { useUser } from '@/stores/user'
import BottomActionsModal from '../BottomActionsModal.vue'
import { useToast } from '@/stores/toast'
import SubtitleText from '../SubtitleText.vue'
import BaseInput from '../BaseInput.vue'
import CoinIcon from '@/assets/icons/coin.svg'
import { client } from '@/api/orpc'
import { useRain } from '@/stores/rain'
import { useLayout } from '@/stores/layout'

const { t } = useI18n({
	messages: {
		en: {
			title: 'tip rain',
			desc: 'You can tip the rain. This will increase it`s pool.',
			amount: 'Tip Amount',
			tip: 'Tip Rain',
			error: 'Error tipping the rain. Please try again later.'
		},
		ru: {
			title: 'добавить в гив',
			desc: 'Ты можешь накинуть монет в гив. Это увеличит его призовой фонд.',
			amount: 'Сумма',
			tip: 'Добавить монеты',
			error: 'Ошибка при добавлении монет в гив. Пожалуйста, попробуй позже.'
		}
	}
})

const model = defineModel<boolean>()

const close = () => {
	model.value = false
}

const toast = useToast()
const amount = ref('1.00')

const user = useUser()
const rain = useRain()
const layout = useLayout()

const loading = ref(false)

const tip = async () => {
	if (loading.value) {
		return
	}

	const parsed = parseFloat(amount.value) || 0
	const coins = Math.floor(parsed * 100)

	if (coins <= 0) {
		amount.value = '0.01'
		return
	}

	if (Math.floor(parsed * 100) > user.displayedCoins) {
		close()
		return layout.showDepositModal(Math.ceil(coins - user.displayedCoins))
	}

	loading.value = true

	const { data, error } = await client.user.tipRain({
		coins
	})

	loading.value = false

	if (error) {
		toast.add({
			type: 'error',
			text: t('error')
		})
		return console.error(error)
	}

	if (!data) {
		return
	}

	user.setBalance(data.updatedUser.coins)
	rain.setPool(data.rainPool)

	close()
}
</script>
